<div class="add-users page-holder bg-gray-100">
    <div class="container-fluid px-lg-4 px-xl-5 min-w-viewport">
        <!-- Page Header-->
        <div class="page-header d-flex justify-content-between align-items-center">
            <h1 class="page-heading">Users</h1>
            <div><a (click)="scrollToAddForom('addUser')"class="btn btn-primary text-uppercase"> <i class="fa fa-plus me-2"> </i>Add new User</a></div>
        </div>
        <div class="col-lg-12 mb-4">
            <div class="card card-table h-100">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Name </th>
                                    <th>User Role</th>
                                    <th>User Group </th>
                                    <th>Email</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody class="align-middle">
                                <tr *ngFor="let row of usersList">
                                    <td> <span class="d-flex align-items-center"><img class="avatar p-1 me-2"
                                                src="https://d19m59y37dris4.cloudfront.net/bubbly/1-2/img/avatar-0.jpg"
                                                alt="Nielsen Cobb"><span class="d-inline-block"><strong>
                                                    {{row.name}}</strong><br><span
                                                    class="text-muted text-sm">Graniteville</span></span></span></td>
                                    <td>
                                        {{row.userRole}}
                                    </td>
                                    <td>
                                        {{row.userGroup}}
                                    </td>
                                    <td>
                                        {{row.email}}
                                    </td>
                                    <td>
                                        <a class="me-3 text-lg text-success"><i class="far fa-edit"></i></a><a
                                            class="text-lg text-danger"><i class="far fa-trash-alt"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer text-end"><a (click)="scrollToAddForom('addUser')" class="btn btn-primary">Add New User</a></div>
            </div>
        </div>
        <div id="addUser" *ngIf ="showAddForm"  [ngClass]= "{'hide': !showAddForm}" class="row mb-5 add-user">
            <div class="card">
                <div class="card-body">
                    <p class="header">Add User</p>
                    <form>
                        <div class="item row mb-5">
                            <div class="col-md-6 mb-3">
                                <label class="form-label text-uppercase">First Name</label>
                                <input class="form-control" type="text" placeholder="First Name">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label text-uppercase">Last Name</label>
                                <input class="form-control" type="text" placeholder="Last Name">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label text-uppercase">Email</label>
                                <input class="form-control" type="email" placeholder="Email Address">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label text-uppercase">Phone Number</label>
                                <input class="form-control" type="text" placeholder="Phone Number">
                            </div>
                        </div>
                        <div class="item">
                            <p class="header">User Roles</p>
                            <div class="col-md-12 d-flex">
                                <div class="form-check mb-4 me-2">
                                    <input class="form-check-input" id="inspector" type="radio" name="userGroup"
                                        (change)="onRadioButtonChange($event)" checked="true">
                                    <label class="custom-control-label" for="inspector">Inspector</label>
                                </div>
                                <div class="form-check mb-4 me-2">
                                    <input class="form-check-input" id="admin" type="radio" name="userGroup"
                                        (change)="onRadioButtonChange($event)">
                                    <label class="custom-control-label" for="admin">Admin</label>
                                </div>
                                <div class="form-check mb-4 me-2">
                                    <input class="form-check-input" id="responsibleOfficial" type="radio"
                                        name="userGroup" (change)="onRadioButtonChange($event)">
                                    <label class="custom-control-label" for="responsibleOfficial">Responsible
                                        Official</label>
                                </div>
                            </div>
                            <div *ngIf="selectedRadioButton=='inspector'" class="mt-2 mb-3 d-flex">
                                <div>
                                    <div class="d-flex">
                                        <div class="me-2 col-md-4">User Group</div>
                                        <div class="mb-2 col-md-8">
                                            <select class="form-control rounded" name="account" multiple="true"
                                                [(ngModel)]="selectedFacilityGroup">
                                                <option>Facility Group 1</option>
                                                <option>Facility Group 2</option>
                                                <option>Facility Group 3</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div>
                                    </div>
                                    <div class="mb-3 sub-header">
                                        <span>Extra Inspection Reminders</span>
                                    </div>
                                    <div class="add-more">
                                        <div class="d-flex mb-3">
                                            <span class="me-2">Hours Before:</span>
                                            <input type="number" id="reminder" name="reminder">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <button (click)="add()" class="btn btn-outline-primary">Add more</button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="selectedRadioButton=='admin'" class="mt-2 mb-3">
                                <div class="d-flex">
                                    <div class="form-check mb-4 me-2">
                                        <input class="form-check-input" id="facilityAdmin" type="radio"
                                            name="adminGroup" (change)="onAdmimRadioButtonChange($event)">
                                        <label class="custom-control-label" for="facilityAdmin">Admin for
                                            Facilities</label>
                                    </div>
                                    <div class="form-check mb-4 me-2">
                                        <input class="form-check-input" id="buAdmin" type="radio" name="adminGroup"
                                            (change)="onAdmimRadioButtonChange($event)">
                                        <label class="custom-control-label" for="buAdmin">Admin for BUs</label>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="col-md-6 me-2 ms-auto select ">
                                        <select class="form-control rounded" multiple="true">
                                            <option>Facility 1</option>
                                            <option>Facility 2</option>
                                            <option>Facility 3</option>
                                            <option>Facility 4</option>
                                        </select>
                                    </div>
                                    <div class="col-md-6 ms-auto select">
                                        <select class="form-control rounded" multiple="true">
                                            <option>BU 1</option>
                                            <option>BU 2</option>
                                            <option>BU 3</option>
                                            <option>BU 4</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="selectedRadioButton=='responsibleOfficial'" class="mt-2 mb-3 d-flex">
                                <div class="me-2">User Group</div>
                                <div class="">
                                    <select class="form-control" name="account" [(ngModel)]="selectedFacilityGroup">
                                        <option>Facility Group 1</option>
                                        <option>Facility Group 2</option>
                                        <option>Facility Group 3</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <button (click)="saveUser()" class="btn btn-primary" type="submit">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="httpService.processing()">
        <app-progress-indicator></app-progress-indicator>
      </div>
      <app-footer class="footer-w"></app-footer>
</div>